import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { FONT, BG, MAIN_BLUE } from '../../styles/color';

const MenuItemWrapper = styled.menu`
    display: inline-block;
    text-align: center;
    list-style: none;
    padding: 0px;
    margin: ${(props) => (props.$key !== 4 ? '0px 50px 0px 0px' : '0px')};
    vertical-align: top;
`;

const MainMenu = styled.li`
    font: normal 650 26px Pretendard Variable;
    color: ${ (props) => (props.$isSelected ? MAIN_BLUE.mid : BG.light01) };
    cursor: pointer;
	
	&:hover {
		cursor: pointer;
	}
`;

 export default function ({isHovered, setIsHovered, data}) {
    const [isSelected, setIsSelected] = useState(false);
    const navigate = useNavigate();

    const handleMouseEnter = () => {
        setIsHovered(true);
        setIsSelected(true);
    }; 

    const handleMouseLeave = () => {
        setIsSelected(false);
    };

    const onMenuClick = (object) => {
        navigate(object.mainMenu.link);
        setIsHovered(false);
    };

    const onClickTemp = () => {
        alert('준비중입니다.');
        navigate('/');
        setIsHovered(false);
    };

    return (
        <MenuItemWrapper onMouseEnter={ handleMouseEnter } onMouseLeave={ handleMouseLeave } $key={data.key}>
            <MainMenu
                $isSelected={ isSelected }
                onClick={ data.mainMenu.isPrepared === false ? onClickTemp : () => onMenuClick(data) }
            >
                {data.mainMenu.title}
            </MainMenu>
        </MenuItemWrapper>
    );
};